import React from "react";

// Titled block inside the notes form / viewer.
export default function NoteSection({ title, children, testId }) {
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4" data-testid={testId}>
      <h3 className="mb-3 text-xs font-bold uppercase tracking-wider text-slate-500">{title}</h3>
      {children}
    </section>
  );
}

export function Field({ label, children, className = "" }) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      <p className="text-xs font-semibold text-slate-600">{label}</p>
      {children}
    </div>
  );
}

export function ReadValue({ children, testId }) {
  return <p className="min-h-9 rounded-md bg-slate-50 px-3 py-2 text-sm text-slate-700" data-testid={testId}>{children}</p>;
}
